<template>
  <!-- Decode the address in the browser only, so it never appears in the delivered HTML -->
  <ClientOnly>
    <slot :href="href" :address="address" />
    <template #fallback>
      <slot :href="null" :address="EMAIL_PLACEHOLDER" />
    </template>
  </ClientOnly>
</template>

<script setup>
import {
  EMAIL_PLACEHOLDER,
  decodeEmail,
  emailAddress,
} from '~/utils/emailObfuscation'

const props = defineProps({
  // token from useCmsGql (or a plain address)
  email: { type: String, required: true },
})

const target = computed(() => decodeEmail(props.email))
const address = computed(() => emailAddress(target.value))
const href = computed(() => `mailto:${target.value.replace(/\s/g, '')}`)
</script>
